import { SvAdSection } from "@/components/SvAdSection/SvAdSection.tsx";

export const AdBlock = () => {
  return (
    <div className="container my-6 md:my-10">
      <SvAdSection className="h-76 w-full" />
    </div>
  );
};
